import loadable from '@loadable/component';

export const CmsLinkButtonLoadable = loadable(() => import('./CmsLinkButton'), {
  resolveComponent: (module) => module.CmsLinkButton,
});
